"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ItemRow = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _shared = require("../../shared");
var _Image = require("../Image");
var _ItemRowDescription = require("./ItemRowDescription");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        gap: theme.spacing(3),
        gridColumnEnd: -1,
        gridColumnStart: 1,
        marginBottom: theme.spacing(3),
        position: 'relative'
    };
});
const ItemImageWrapper = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        flexShrink: 0,
        height: 120,
        overflow: 'hidden',
        position: 'relative',
        width: 120,
        [theme.breakpoints.only('xs')]: {
            height: 80,
            width: 80
        }
    };
});
const ItemRow = (param)=>{
    let { 'data-testid': dataTestId, imageUrl, isBenefit, isPurchased = false, itemCode, name, price, productDetailUrl, purchasePrice, replacement, selectedQuantity } = param;
    const { getTestId } = (0, _testidGenerator.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Root, {
        "data-testid": dataTestId,
        children: [
            isBenefit ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_shared.Badge, {
                ownerState: {
                    isIcon: true
                },
                "data-testid": getTestId('badge'),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_icons.DiscountTagFilled, {
                    fontSize: "inherit"
                })
            }) : null,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(ItemImageWrapper, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Image.ItemImage, {
                    isTransparent: isPurchased,
                    name: name,
                    productDetailUrl: productDetailUrl,
                    src: imageUrl
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ItemRowDescription.ItemRowDescription, {
                "data-testid": getTestId('item-description'),
                isPurchased: isPurchased,
                itemCode: itemCode,
                name: name,
                price: price,
                purchasePrice: purchasePrice,
                replacement: replacement,
                selectedQuantity: selectedQuantity
            })
        ]
    });
};
exports.ItemRow = ItemRow;
